import { createFileRoute } from "@tanstack/react-router";
import { ToolEditPage } from "@client/components/tool-workshop/tool-edit-page";

function RouteComponent() {
  const { toolId } = Route.useParams();
  return <ToolEditPage key={toolId} />;
}

export const Route = createFileRoute("/_app/bots/tools/$toolId")({
  component: RouteComponent,
});
